import { OnboardingMileageScreen } from "@/components/screens/onboarding/MileageScreen"
import { useAcceptTerms } from "@/queries/useAcceptTerms"
import { useNavigate } from "@/router"
import { currentAuthAtom } from "@/state/auth"
import { mileageDraftAtom } from "@/state/draft/mileage"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom, useAtomValue } from "jotai"
import { useEffect } from "react"
import { useGetReport } from "@/queries/useReport"
import { periodDraftAtom } from "@/state/draft/period"
import { PlainDate } from "@/utils/date"

export default function MileagePage() {
	const { sendEvent } = useAnalytics("Create_Mileage")

	useEffect(() => {
		sendEvent("Step_TotalMiles__View")
	}, [])
	const [mileage, setMileage] = useAtom(mileageDraftAtom)
	const navigate = useNavigate()
	const authState = useAtomValue(currentAuthAtom)
	const { mutateAsync: acceptTerms } = useAcceptTerms(authState.reportId, authState.key)
	const report = useGetReport()
	const period = useAtomValue(periodDraftAtom)
	const handleTermsAccept = () => {
		acceptTerms()
	}
	return (
		<OnboardingMileageScreen
			dateRange={[PlainDate.from(period.range[0]), PlainDate.from(period.range[1])]}
			value={mileage}
			onSubmit={(data) => {
				setMileage(data)
				sendEvent("Step_TotalMiles__Continue")
				navigate("/report/create/generating")
			}}
			onBack={() => {
				navigate("/report/create/address")
			}}
			onTermsAccept={handleTermsAccept}
			termsAccepted={!!report?.data?.terms_accepted}
		/>
	)
}
